export const API = {
    BASE_URL: 'https://monica-api.com',            //Produccion
    //BASE_URL: 'http://localhost:4000',              //Local Host
}